<template>
  <custom-dropdown-group :group-header="checkboxGroupTitle">
    <template v-slot:group-content>
      <v-flex xs12>
        <v-checkbox
          v-for="item in checkboxOptions"
          :key="item.value"
          v-model="selectedOptions"
          :label="item.text"
          :value="item"
          hide-details
          class="checkbox-option"
        />
      </v-flex>
    </template>
  </custom-dropdown-group>
</template>

<script>
import CustomDropdownGroup from '../../common/search/CustomDropdownGroup.vue'
import { isEmpty } from '../../../utils/generalUtils'
export default {
  components: { CustomDropdownGroup },

  props: {
    checkboxGroupTitle: {
      type: String,
      default: ''
    },
    checkboxOptions: {
      type: Array,
      required: true
    },
    preSelected: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedOptions: []
    }
  },

  watch: {
    selectedOptions: {
      handler: function(newValue, oldValue) {
        this.$emit('update-selection', newValue)
      },
      deep: true
    },

    preSelected(newValue, oldValue) {
      if (!isEmpty(newValue) && newValue.length !== this.selectedOptions.length) {
        this.selectedOptions = [...newValue]
      } else if (isEmpty(newValue) && !isEmpty(this.selectedOptions)) {
        this.selectedOptions = []
      }
    }
  }
}
</script>

<style lang="sass">
.checkbox-option
  margin-top: 6px !important
  label
    font-size: 1.4rem !important
  .v-input--selection-controls__input
    height: 20px
</style>
